<template>
  <div class="footerpage">
    <footer>
      <div class="footer-menus">
        <div class="service-menu footer-menu">
          <p class="menu-title">合作伙伴</p>
          <ul class="menu-items">
            <li>
              <a href="/cms/cmsadmin/wcm/logout.jsp" target="black">站群系统</a>
            </li>
            <li>
              <a href="https://www.xuetangx.com/" target="black">学堂在线</a>
            </li>
            <li>
              <a href="https://www.yuketang.cn/" target="black">雨课堂</a>
            </li>
          </ul>
        </div>
        <div class="service-menu footer-menu">
          <p class="menu-title">友情链接</p>
          <ul class="menu-items">
            <li>
              <a href="https://www.hep.com.cn/" target="black">
                高等教育出版社
              </a>
            </li>
            <li>
              <a
                href="http://www.tup.tsinghua.edu.cn/index.html"
                target="black"
              >
                清华大学出版社
              </a>
            </li>
            <li>
              <a href="http://www.cqup.com.cn/index.php" target="black">
                重庆大学出版社
              </a>
            </li>
            <li>
              <a href="https://www.ptpress.com.cn/" target="black">
                人民邮电出版社
              </a>
            </li>
          </ul>
        </div>
        <div class="service-menu footer-menu">
          <p class="menu-title">帮助支持</p>
          <ul class="menu-items">
            <li>
              <a href="https://www.fltrp.com/" target="black">
                外语教学与研究出版社
              </a>
            </li>
            <li>
              <a href="https://cucp.cuc.edu.cn/" target="black">
                中国传媒大学出版社
              </a>
            </li>
            <li>
              <a href="https://www.pmph.com/" target="black">人民卫生出版社</a>
            </li>
            <li>
              <a href="http://www.fudanpress.com/default.asp" target="black">
                复旦大学出版社
              </a>
            </li>
          </ul>
        </div>
      </div>
      <!-- <div class="cut-off-rule">
        
      </div> -->
      <!-- <div class="spans-wrapper">
        <span class="icp-info">版权所有©北京英华在线科技有限公司</span>
        <span class="rights">
          <a href="https://beian.miit.gov.cn/" target="black">
            京ICP备20031688号
          </a>
        </span>
        <span class="rights one">
          <a href="https://beian.miit.gov.cn/" target="black">
            京公网安备 11011502004263号
          </a>
        </span>
      </div> -->
    </footer>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  props: {
    msg: String,
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
.footerpage {
  width: 100%;
  background-color: #f0f0f0;
  footer {
    /*margin-top: 124px;
    display: grid;
    justify-items: center;
    */
    display: flex;
    justify-content: space-between;
    justify-content: space-around;
    padding: 20px 30px 0 30px;
    flex-wrap: wrap;
    padding-top: 48px;

    margin: 0 auto;
  }
  .footer-menus {
    width: 1200px;
    width: 100%;
    max-width: 1180px;
    display: flex;
    justify-content: space-between;
    padding: 0 247px;
    position: relative;
  }
  .menu-title {
    font-size: 14px;
    color: #333333;
    font-weight: 600;
    margin-bottom: 30px;
  }
  .contact-us {
    margin-right: 80px;
    justify-self: end;
    color: #c0c0c0;
  }
  .contact-us a {
    text-decoration: none;
    font-weight: 500;
    color: #c0c0c0;
  }
  .contact-us p:not(:first-child) {
    padding-bottom: 8px;
  }
  .menu-items li {
    list-style: none;
    padding-bottom: 20px;
  }
  .menu-items li a {
    font-size: 14px;
    text-decoration: none;
    font-weight: 500;
    color: #333333;
  }
  .cut-off-rule{ 
    margin-top: 60px;
    width: 100%;
    height: 1px;
    background: #D7D7D7;
  }
  .spans-wrapper {
    max-width: 1200px;
    display: flex;
    width: 100%;
    padding: 0 264px;
    justify-content: space-between;
    align-items: center;
  }

  .spans-wrapper .icp-info {
    justify-self: end;
  }
  .icp-info {
    font-size: 13px;
    color: #4d4d4d;
    margin-top: 14px;
    margin-bottom: 14px;
  }
  .icp-info,
  .rights,
  .rights a,
  .icp-info a {
    font-size: 13px;

    margin-top:14px;
    margin-bottom: 14px;
    justify-self: center;

    color: #4d4d4d;
    text-decoration: none;
  }
  .one {
    width: 225px;
  }

  .service-men {
    justify-self: center;
  }
  .service-menu img {
    max-width: 110px;
    max-height: 110px;
  }
  .service-menu .messages {
    margin-left: 20px;
  }
}
</style>
